var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["makeResolve"]: function() { return __WEBPACK_EXTERNAL_MODULE_swagger_client_es_resolver_f879c638__.makeResolve; } });